import { useState } from 'react'
import { ChevronDownIcon, ChevronUpIcon } from '@radix-ui/react-icons'
import * as SelectPrimitive from '@radix-ui/react-select'
import clsx from 'clsx'

type SelectProps = {
  defaultValue: string
  options: Array<{ label: string, value: string }>
  onValueChange: (value: string) => void
}

export const Select = ({
  defaultValue,
  options,
  onValueChange,
}: SelectProps) => {
  const [open, setOpen] = useState(false)
  const [triggerWidth, setTriggerWidth] = useState<number>()

  return (
    <SelectPrimitive.Root
      open={open}
      onOpenChange={setOpen}
      onValueChange={onValueChange}
      defaultValue={defaultValue}
    >
      <SelectPrimitive.Trigger asChild>
        <button
          className="flex items-center justify-between w-full px-4 py-3 text-sm font-medium border rounded-md text-grey-700 border-grey-500"
          ref={(node) => node && setTriggerWidth(node.offsetWidth)}
        >
          <SelectPrimitive.Value />
          <SelectPrimitive.Icon className="ml-2">
            {open ? <ChevronUpIcon /> : <ChevronDownIcon />}
          </SelectPrimitive.Icon>
        </button>
      </SelectPrimitive.Trigger>

      <SelectPrimitive.Content
        position="popper"
        sideOffset={4}
        className="z-50 overflow-hidden border rounded-md border-primary-light"
        style={{ width: triggerWidth || undefined }}
      >
        <SelectPrimitive.Viewport className="bg-white shadow-lg">
          <SelectPrimitive.Group>
            {options.map(({ label, value }, index) => (
              <SelectPrimitive.Item
                key={`${value}-${index}`}
                value={value}
                className={clsx(
                  'data-[state="checked"]:bg-primary-light h-10 font-normal data-[state="checked"]:font-medium data-[state="checked"]:text-white relative flex items-center px-4 py-3 text-sm text-gray-700 ',
                  'radix-disabled:opacity-50',
                  'focus:outline-none cursor-pointer'
                )}
              >
                <SelectPrimitive.ItemText>{label}</SelectPrimitive.ItemText>
              </SelectPrimitive.Item>
            ))}
          </SelectPrimitive.Group>
        </SelectPrimitive.Viewport>
      </SelectPrimitive.Content>
    </SelectPrimitive.Root>
  )
}
